import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";

import { wsIDPrinterLockoutUpdateParm } from "./wsIDPrinterLockoutUpdateParm";
import { wsIDPrinterLockoutItems } from "./wsIDPrinterLockoutUpdateParm";

@Injectable()
export class DataService_idprintlockout {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	IDPrinterLockoutSelectList
	//
	//-----------------------------------------------------------------------------------------------------
	IDPrinterLockoutSelectList() 
	{
		var postResult$ = new Subject();
		var url = "PhotoID/IDPrinterLockoutSelectList";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	IDPrinterLockoutUpdate
	//
	//-----------------------------------------------------------------------------------------------------
	IDPrinterLockoutUpdate(selected: wsIDPrinterLockoutUpdateParm) 
	{
		var postResult$ = new Subject();
		var url = "PhotoID/IDPrinterLockoutUpdate";

		var promise$ = this.httpclientService.post(url, selected);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}	
}
